import type { ConsentKind, Market } from "@ferrivia/api-contract";

// Three checkboxes where the Glide app shows two — see ConsentsStep for why.
// Shared between ConsentsStep (rendering) and OnboardingFlow (the submission
// payload and step-validity check) so the order and the set of kinds can't
// drift between the two.
//
// health_questionnaire_collection is deliberately not one of these three —
// it's captured just-in-time by the questionnaire flow, not here — so this
// is typed as its own subset rather than the full ConsentKind.
export const CONSENT_KINDS = [
  "terms_and_privacy",
  "health_data_processing",
  "lab_partner_result_upload",
] as const satisfies readonly ConsentKind[];
export type OnboardingConsentKind = (typeof CONSENT_KINDS)[number];

// The US has no lab partner, so it never asks for lab-result upload consent.
export const US_CONSENT_KINDS = [
  "terms_and_privacy",
  "health_data_processing",
] as const satisfies readonly OnboardingConsentKind[];

export function consentKindsFor(market: Market): readonly OnboardingConsentKind[] {
  return market === "us" ? US_CONSENT_KINDS : CONSENT_KINDS;
}
